/**
 * The "Overrides" section of the sliding job launch drawer.
 * Let the user specify overrides (args, config, entry point) for
 * what we are launching.
 */

import React from 'react';

import {CodeEditor} from '../CodeEditor';
import {JobRun} from '../JobDetail/utilTypes';

type JobDrawerOverridesProps = {
  overrides: string;
  onOverridesChange: (value: string) => void;
  onSelectRun: (run: JobRun | null) => void;
};

export const JobDrawerOverrides = ({
  overrides,
  onOverridesChange,
  onSelectRun,
}: JobDrawerOverridesProps) => {
  // When user manually edits overrides, clear the selected run to clone
  const onChange = (value: string) => {
    onSelectRun(null);
    onOverridesChange(value);
  };

  return <CodeEditor value={overrides} language="json" onChange={onChange} />;
};
